import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface SetActiveProfileResponse extends BackendResponse {}

export interface SetActiveProfileParameters extends NextApiParams {
  k: number;
  candidateId: number;
}

/** Backend message returned when SetActiveProfile is called for a candidate
 *  whose email the user hasn't verified. Kept in sync with
 *  AuthController.MsgProfileEmailNotVerified. */
export const MSG_PROFILE_EMAIL_NOT_VERIFIED = "Profile email not verified";

export const setActiveProfile = withNextApi<
  SetActiveProfileResponse,
  SetActiveProfileParameters
>("/auth/SetActiveProfile", {
  f: async (args, f) => {
    try {
      return await f(args);
    } catch (err: any) {
      const message: string =
        err?.response?.data?.message ?? err?.result?.message ?? err?.message ?? "";
      if (typeof message === "string" && message.includes(MSG_PROFILE_EMAIL_NOT_VERIFIED)) {
        // The user picked a candidate whose email they haven't proved ownership
        // of. Send them to /cvpenter where the verification flow lives.
        window.location.href = `/cvpenter?k=${args.k}`;
        // Don't propagate — let the redirect take over.
        return { ok: false, message } as SetActiveProfileResponse;
      }
      throw err;
    }
  },
});
